/**
 * 2023 Tax Year Rules
 * Combines federal and state rules
 */

import { TaxRules } from '../../types';
import { cashMedicalSupportLevelsIA2023 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2023 } from './IA/childSupportLevels';

export const taxRules2023: TaxRules = {
    year: 2023,
    federal: {
        filing: {
            single: {
                standardDeduction: 13850,
                over65Deduction: 1850,
                blindDeduction: 1850,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 10275.99, rate: 0.10 },
                    { minimumIncome: 10276, maximumIncome: 41775.99, rate: 0.12 },
                    { minimumIncome: 41776, maximumIncome: 89075.99, rate: 0.22 },
                    { minimumIncome: 89076, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 539900.99, rate: 0.35 },
                    { minimumIncome: 539901, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 13850,
                over65Deduction: 1850,
                blindDeduction: 1850,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 10275.99, rate: 0.10 },
                    { minimumIncome: 10276, maximumIncome: 41775.99, rate: 0.12 },
                    { minimumIncome: 41776, maximumIncome: 89075.99, rate: 0.22 },
                    { minimumIncome: 89076, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 323925.99, rate: 0.35 },
                    { minimumIncome: 323926, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 20800,
                over65Deduction: 1850,
                blindDeduction: 1850,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 14650.99, rate: 0.10 },
                    { minimumIncome: 14651, maximumIncome: 55900.99, rate: 0.12 },
                    { minimumIncome: 55901, maximumIncome: 89050.99, rate: 0.22 },
                    { minimumIncome: 89051, maximumIncome: 170050.99, rate: 0.24 },
                    { minimumIncome: 170051, maximumIncome: 215950.99, rate: 0.32 },
                    { minimumIncome: 215951, maximumIncome: 539900.99, rate: 0.35 },
                    { minimumIncome: 539901, rate: 0.37 },
                ],
            }
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 2.9,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 160200,
            additionalMedicareTaxThreshold: 200000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2000,
            federalRefundableAmountPerChildUnder17: 1600,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1000,
        },
        qbi: {
            thresholdStart: 164900,
            thresholdEnd: 999_999_999_999,
            tentativeRate: 999_999_999,
            thresholdRate: 2.5,
        },
        earnedIncome: {
            threshold: 2500,
            agiMultiplier: 15, // as percentage
        },
        dependentCare: {
            limitOneDependent: 3000,
            limitTwoOrMoreDependents: 6000,
        },
    },
    states: {
        IA: {
            // Iowa state tax - progressive brackets for 2023
            standardDeductionSingle: 0,
            standardDeductionMarriedFilingSeparately: 0,
            standardDeductionHeadOfHousehold: 0,
            over65Deduction: 20,
            blindDeduction: 20,
            brackets: [
                { minimumIncome: 0, maximumIncome: 6000.99, rate: 0.044 },
                { minimumIncome: 6001, maximumIncome: 30000.99, rate: 0.0482 },
                { minimumIncome: 30001, maximumIncome: 75000.99, rate: 0.057 },
                { minimumIncome: 75001, rate: 0.06 },
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2023,
                cashMedicalSupport: cashMedicalSupportLevelsIA2023,
            },
        },
    }
};
